import { Popover } from '@mui/material';
import { useState, useEffect } from 'react';
import { SketchPicker, ColorResult } from 'react-color';

interface ColorPickerPopoverProps {
  isOpen: boolean;
  onClose: () => void;
  currentColor: string;
  anchorEl: HTMLElement | null;
  onColorChange: (color: string) => void;
  onBackgroundColorChange?: (args: { schemeName: string; color: string }) => void;
  selectedMenu?: string;
}

const ColorPickerPopover = ({
  isOpen,
  onClose,
  currentColor,
  anchorEl,
  onColorChange,
  onBackgroundColorChange,
  selectedMenu,
}: ColorPickerPopoverProps) => {
  const [localColor, setLocalColor] = useState(currentColor);

  useEffect(() => {
    setLocalColor(currentColor);
  }, [currentColor]);

  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <div>
        <SketchPicker
          color={localColor}
          className="sketchPicker"
          width="16rem"
          onChange={(color: ColorResult) => {
            setLocalColor(color.hex);
            onColorChange(color.hex);
            if (selectedMenu && onBackgroundColorChange) {
              onBackgroundColorChange({
                schemeName: selectedMenu,
                color: color.hex,
              });
            }
          }}
          disableAlpha
        />
      </div>
    </Popover>
  );
};

export default ColorPickerPopover;
